export const notificationKeys = {
  all: ['notifications'] as const,
  bell: () => [...notificationKeys.all, 'bell'] as const,
  unread: () => [...notificationKeys.all, 'unread'] as const,
}
